<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">

      <!-- update-begin- author:sunjianlei --- date:20190814 --- for: logo颜色根据主题颜色变化 -->
      <img v-if="navTheme === 'dark'" src="~@/assets/haichang.png" alt="logo">
      <!--<img v-else src="~@/assets/logos.jpg" style="width: 67px;height: 54px;" alt="logo">-->
      <img v-else src="~@/assets/haichang.png" style="width: auto;height: 44px;" alt="logo">
      <!-- update-begin- author:sunjianlei --- date:20190814 --- for: logo颜色根据主题颜色变化 -->

      <!--  <h1 v-if="showTitle">{{ title }}</h1>-->
<!--      <img src="~@/assets/DADI_LOGO.png" alt="logo">-->
      <!--      <h1 v-if="showTitle">{{ title }}</h1>-->
    </router-link>
  </div>
</template>

<script>
import { mixin } from '@/utils/mixin.js'

export default {
  name: 'Logo',
  mixins: [mixin],
  props: {
    title: {
      type: String,
      default: 'logo',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
<style lang="less" scoped>
/*缩小首页布 局顶部的高度*/
@height: 59px;

.sider {
  box-shadow: none !important;
  .logo {
    height: @height !important;
    line-height: @height !important;
    box-shadow: none !important;
    transition: background 300ms;

    a {
      color: white;
      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  &.light .logo {
    //background-color: @primary-color;
  }
}
</style>